import {AssetsQaRequestParams} from "../../../../infrastructure/models/params/assets-qa-request-params";

export class WizardAssetsRequestParams extends AssetsQaRequestParams {
  rotate: Number;

  constructor(width: Number,height: Number, color: String) {
    super(width, height, color);

    this.resourceName = this.resourceName + '/wizard';
  }

  get angle() {
    return this.rotate;
  }
}
